import Velocity from 'velocity-animate'
import 'velocity-animate/velocity.ui'
import { isFunction } from 'lodash-es'
import logger from '../logger'

// ////////////////////////////////
// Element Animation Transition //
// ////////////////////////////////

export default {
  init() {
    logger('init CollapseTransition', 'debug')()
  },
  collapse(primaryEl, cb, options = {}) {
    // target all DOM nodes
    const $primaryEl = this.root.querySelector(primaryEl)
    const DURATION = options.duration || 250

    // animate the parent to the new height
    const primarySequence = [{
      e: $primaryEl,
      p: {
        height: 0,
        opacity: 0,
        'z-index': -1,
      },
      o: {
        duration: DURATION,
        easing: 'easeInOutQuint',
        complete: () => {
          if (isFunction(cb)) cb.call(this)
        },
      },
    }]

    Velocity.RunSequence(primarySequence)
  },
}
